import { render, staticRenderFns } from "./ErrorFlash.vue?vue&type=template&id=4d9fe920&"
import script from "./ErrorFlash.vue?vue&type=script&lang=js&"
export * from "./ErrorFlash.vue?vue&type=script&lang=js&"
import style0 from "./ErrorFlash.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports